module.exports = __webpack_public_path__ + "static/media/fb-icon.6f64dcd8.png";